import "./card.css";

export default function Card({ children }) {
  return <div className="trycatch-card">{children}</div>;
}
